import '../styles/Contacto.css'

const Contacto = () => {
    return (
        <>
            {/* desktop */}
            <div className=' d-none d-lg-block'>
                <div className='home p-0 '> 
                    <div className='container-cookie bannerInicial'>
                        <div className='row bannerI'>
                            <div className='col-12 col-md-6 col-image p-0 '>
                                <div className='home__image-container' style={{background:'white'}}> 
                                    <img src='/assets/img/homeout/img-contacto.png' className="home__image_contact" alt='' />
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-back  '>
                                <div className='h-100 w-100 row col  '>
                                    
                                    <div className="  d-flex justify-content-center  align-items-end w-75 mx-auto  ">
                                        <div className="card__contacto-img d-none d-lg-block  h-50 me-3 ">
                                            <img src='/assets/img/homeout/contacto/ico-fono.svg' alt="icono_telefono" className="d-none d-lg-block"/>
                                        </div>
                                        <div className='div__telefono h-50 '>
                                            <p className="card__contacto-description  ">Si tienes alguna inquietud o consulta, comunícate con nosotros en nuestra línea de atención en:</p>
                                            <div className='d-lg-none d-block '><br/></div>
                                            <p className="card__contacto-description mt-3" style={{fontSize:'16px', color: 'var(--green)', fontWeight:'bold'}}>Línea de atención Cardif: <a style={{'color': 'var(--lime-greem)'}} href='tel:800 801 0132'>800 801 0132</a><br/><div className='breakLine'></div>Horarios de atención: <br/><div className='breakLine'></div>Lunes a Sábados de 09:00 a 18:00 hrs.</p>
                                        </div>
                                    </div>

                                    <div className="  d-flex  align-items-start   w-75 mx-auto  ">
                                        <div className="card__contacto-img d-none d-lg-block h-50 me-3   ">
                                            <img src='/assets/img/homeout/contacto/ico-correo.svg' alt="icono_correo" className="d-none d-lg-block"/>
                                        </div>
                                        <div className='div__telefono h-50'>
                                            <p className="card__contacto-description">También puedes escribirnos a nuestro correo electrónico:</p>
                                            <div className='d-lg-none d-block'><br/></div>
                                            <p className="card__contacto-description mt-3" style={{fontSize:'16px', color: 'var(--green)', fontWeight: 'bold'}}><a style={{'color': 'var(--lime-greem)'}} href='mailto:sac_mx@cardif.com.mx'>sac_mx@cardif.com.mx</a></p>
                                        </div>
                                    </div>  

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* mobil */}
            <div className='d-lg-none'>
                <div className=' mb-5  '>  
                    <div className=' '  >
                        <div className='' > 
                            <img src='/assets/img/homeout/img-contacto-mobil.png' className="img_contacto" alt='' />
                        </div>
                    </div>                  
                    <div className='div__telefono h-75 mx-5 h3 mt-5'>   
                        <h1 className="titulo__contacto">Contáctanos</h1>         
                        <div className="">                                       
                            <p className="">Si tienes alguna inquietud o consulta, comunícate con nosotros en nuestra línea de atención en:</p>
                        </div>
                        <div className='mt-4 '>                                        
                            <p className="me-3 " style={{fontSize:'15px', color: 'var(--green)', fontWeight:'bold'}}>Línea de atención Cardif:<br/> 
                                <a style={{'color': 'var(--lime-greem)'}} href='tel:800 801 0132'> 800 801 0132</a>                                    
                            </p>                                        
                        </div>
                        <div className='my-4 text-verde fw-bold '>
                            <p> Horarios de atención: </p>
                            <p> Lunes a Sábados de 09:00 a 18:00 hrs.</p>
                        </div>                                                                         
                        <div className=''>
                            <p className="">También puedes escribirnos a nuestro correo electrónico:</p>                                            
                            <p className="mt-4" style={{fontSize:'15px', color: 'var(--green)', fontWeight: 'bold'}}>
                                <a style={{'color': 'var(--lime-greem)'}} href='mailto:sac_mx@cardif.com.mx'>sac_mx@cardif.com.mx</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contacto